import { useState, useCallback } from "react";
import { NotificationChannel } from "../types/alerts";
import { mockChannels } from "../data/mockAlerts";

export function useChannels(initialChannels?: NotificationChannel[]) {
  const [channels, setChannels] = useState<NotificationChannel[]>(initialChannels || mockChannels);
  const [selectedChannels, setSelectedChannels] = useState<string[]>([]);

  const addChannel = useCallback((channel: NotificationChannel) => {
    setChannels((prev) => [...prev, channel]);
  }, []);

  const updateChannels = useCallback((updatedChannels: NotificationChannel[]) => {
    setChannels(updatedChannels);
  }, []);

  const toggleChannelSelection = useCallback((channelId: string) => {
    setSelectedChannels((prev) =>
      prev.includes(channelId) ? prev.filter((id) => id !== channelId) : [...prev, channelId]
    );
  }, []);

  const setSelectedChannelsList = useCallback((channelIds: string[]) => {
    setSelectedChannels(channelIds);
  }, []);

  return {
    channels,
    selectedChannels,
    addChannel,
    updateChannels,
    toggleChannelSelection,
    setSelectedChannels: setSelectedChannelsList,
  };
}
